<template>
  <page :load="doInit">
    <template slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              More Links...
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="sideMenuClick"></side-function-menu>
        </v-menu>
      </div>
    </template>
    <v-card>
      <v-card-text>
        <v-container fluid grid-list-sm>
          <v-layout row wrap>
            <v-flex xs4>
              <v-subheader class="queryLabel">{{labels.insdRefNo}}</v-subheader>
              <div class="queryValue">{{insured.insdRefNo}}</div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <transition name="slide-x-transition" mode="out-in">
        <router-view :routerKey="routerKey"></router-view>
      </transition>
    </v-card>
  </page>
</template>

<script>
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'
import { mapGetters, mapActions } from 'vuex'
import routeMixin from '@/mixins/route'

export default {
  data() {
    return {
      labels: {
        insdRefNo: 'Insured Reference'
      },
      sideMenu: [
        { name: 'queryDetails', text: 'Details', icon: 'mdi-account' },
        { name: 'queryCurrPortfolioMenu', text: 'Current Portfolio', icon: 'mdi-folder-account' }
      ],
      sideFunction: [
        { text: 'Details', icon: 'mdi-account', iconColor: 'primary', params: { key: 'queryDetails' } },
        { text: 'Current Portfolio', icon: 'mdi-account', iconColor: 'primary', params: { key: 'queryCurrPortfolioMenu' } }
      ],
      routerKey: undefined
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    insured() {
      return this.$store.state.adminInsured.insured
    }
  },
  methods: {
    ...mapActions([
      'insuredMenuInit'
    ]),
    async doInit() {
      await this.insuredMenuInit(this.insdRefNo)
      this.routerKey = 'queryDetails'
    },
    sideMenuClick(data) {
      this.$router.push({ name: data.key, params: data.params })
    }
  },
  props: ['insdRefNo', 'clientGrp'],
  components: {
    SideFunctionMenu
  },
  mixins: [
    routeMixin
  ]
}
</script>

<style lang="scss">
.queryPnl {
  margin-top: 50px;
}
.smallMenu { width: 400px !important; }
</style>
